import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ConfigurationService } from '../../../Configuration/configuration.service';
const opts: any = {
  headers: new HttpHeaders({
    'Accept': 'text/html, application/xhtml+xml,application/json, */*',
    'Content-Type': 'text/plain; charset=utf-8, application/json'
  }),
  responseType: 'text'
};
@Injectable({
  providedIn: 'root'
})
export class SubmissionsapiService {

  constructor(private http: HttpClient, private configService: ConfigurationService) { }
  private apiUrl = this.configService.getAPIBaseUrl(); // Base URL for your API
  currentcharityid: number | null;


  Submission(data: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Submission/FinalSubmission`;
    //return this.http.get<any>(url + "?id=" + id);

    const headers = new HttpHeaders({ 'Content-Type': 'application/xml' });
    headers.append('Accept', 'application/xml');
    headers.append('Content-Type', 'application/xml');
    return this.http.post(url, data, { responseType: 'text' });
  }
  //GetSelectedReports(Selectedcheckboxes: any,ReportData:any): Observable<any> {
  //  debugger
  //  const url = `${this.apiUrl}/Submission/GetSelectedcheckboxesReports`;

  //  const headers = new HttpHeaders({ 'Content-Type': 'application/xml' });
  //  headers.append('Accept', 'application/xml');
  //  headers.append('Content-Type', 'application/xml');
  //  return this.http.post(url, Selectedcheckboxes, ReportData, { responseType: 'text' });
  //  //return this.http.post('https://your-api-url/api/SubmitExportSelections', selectedcheckboxes);
  //}
  GetSelectedReports(formData: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Submission/GetSelectedcheckboxesReports`;
    return this.http.post(url, formData, { responseType: 'text' });
  }
  FBIReceipt(subid:any) {
    const url = `${this.apiUrl}/Reports/FBIReceiptReports?id=${subid}`;
    return this.http.post(url, opts);
  }
  errorReport(subid: any) {
    const url = `${this.apiUrl}/Reports/ErrorReport?id=${subid}`;
    return this.http.post(url, opts);
  }

  getXmldata(ID: any): Observable<any> {
    const url = `${this.apiUrl}/Submission/GetXmldata?ID=`;
    return this.http.get<any>(url + ID);
  }
  getError(ID: any): Observable<any> {
    const url = `${this.apiUrl}/Submission/GetError?ID=`;
    return this.http.get<any>(url + ID);
  }

  getSubmissionhistory(ID: any): Observable<any> {
    const url = `${this.apiUrl}/Submission/GetSubmissionHistory?ID=`;
    return this.http.get<any>(url + ID);
  }
  getcharities(ID: any): Observable<any> {
    const url = `${this.apiUrl}/Submission/GetCharities?ID=`;
    return this.http.get<any>(url + ID);
  }

  GetSubmissionDetails(SubmissionId: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Submission/GetSubmissionDetails?SubmissionId=`;
    return this.http.get<any>(url + SubmissionId);
  }

  GetSubmissionStatus(data: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Submission/GetSubmissionStatus`;
    //return this.http.get<any>(url + "?id=" + id);

    const headers = new HttpHeaders({ 'Content-Type': 'application/xml' });
    headers.append('Accept', 'application/xml');
    headers.append('Content-Type', 'application/xml');
    return this.http.post(url, data, { responseType: 'text' });
  }

  getCharitySubmissions(charityid: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Submission/GetCharitySubmissionHistory?ID=`;
    return this.http.get<any>(url + charityid);
  }
  downloadFile(url: string): any {
    debugger
    return this.http.get(url, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }
}
